<template>
  <div v-loading="talentLoading" style="min-height: 200px">
    <div v-if="orgData && orgData.length && !talentLoading">
      <div class="person-item" v-for="(item,i) in orgData" :key="i">
        <div style="margin-left: 8px" @click="goOrgDetails(item)">
          <div class="person-name">
            {{ item.nameCn }}
<!--            <span style="color: #00000E65;font-size: 14px;margin-left: 10px;line-height: 18px">{{ item.tag?.join(' ') }}</span>-->
          </div>
          <div class="item-left">
            所在地:<span class="item-num" style="margin-right: 9px;color: #50607F">{{ item.province || '-' }}</span>
            <span v-if="item.province && item.city" style="color: #50607F">{{item.city}}</span>
          </div>
          <div class="item-left">
            专利数:<span class="item-num" style="margin-right: 9px">{{ item.pubCount[1].count || '0' }}</span>
            论文数:<span class="item-num">{{ item.pubCount[0].count || '0' }}</span>
          </div>
          <div class="item-left">主要技术领域:
            <span class="item-right" v-if="!item.fieldList || item.fieldList.length === 0">-</span>
            <span class="item-right" v-if="item.fieldList && item.fieldList?.length > 5">{{ item.fieldList.slice(0, 5)
              }}...</span>
            <span class="item-right" v-else>{{ item.fieldList?.join(',') || '' }}</span>
          </div>

          <div class="item-left">主要研究方向:
            <span class="item-right" v-if="!item.interestList || item.interestList.length === 0">-</span>
            <span class="item-right"
                  v-else-if="item.interestList && item.interestList?.length > 5">{{ item.interestList.slice(0, 5)
              }}...</span>
            <span class="item-right" v-else>{{ item.interestList?.join(',') || '' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <el-empty />
    </div>
  </div>
</template>

<script>

export default {
  name: 'orgList',
  components: {},
  props: ["orgData",'talentLoading'],

  created() {},
  methods: {
    goOrgDetails(item){
      let obj = {
        name: 'orgDetail',
        query: { orgId: item.id, orgType: item.orgType, orgArea: item.country === '中国'?'国内':'国外' },
      };
      let routeData = this.$router.resolve(obj);
      window.open(routeData.href, '_blank');
    },
  },
  watch: {}
};
</script>

<style scoped lang="less">

.person-item {
  margin: 5px 19px;
  display: flex;
  cursor: pointer;
  padding: 15px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #DEE2E9;

  .person-name {
    align-items: center;
    font-weight: 500;
    line-height: 24px;
    font-size: 18px;
    color: #181F33;
  }

  .item-left {
    margin-top: 11px;
    line-height: 24px;
    font-size: 14px;
    color: #8191B2;
  }

  .item-right {
    font-size: 14px;
    color: #50607F;
    margin-left: 8px;
  }

  .item-num {
    line-height: 24px;
    font-size: 14px;
    color: #3860F4;
    margin-left: 4px;
  }
}

</style>
